export enum OrderDisputeType {
  First = 'first',
  Reopened = 'reopened',
}
